import { Directive, ElementRef, NgZone, OnDestroy, OnInit } from '@angular/core';

// Adds `.stuck` to a position: sticky element while it is pinned at its `top` (owner 2026-10-12: the tool
// pages' chip bar takes the editor background only once it sticks, and shows the page under it at rest).
@Directive( {
  selector: '[appStuck]',
} )
export class StuckDirective implements OnInit, OnDestroy {

  private readonly check = () => {
    const el = this.host.nativeElement;
    const top = parseFloat( getComputedStyle( el ).top ) || 0;
    el.classList.toggle( 'stuck', el.getBoundingClientRect().top <= top + 0.5 && ( document.body.scrollTop || document.documentElement.scrollTop ) > 0 );
  };

  constructor( private host: ElementRef<HTMLElement>, private zone: NgZone ) {
  }

  ngOnInit(): void {
    if ( typeof document === 'undefined' ) { return; }
    this.zone.runOutsideAngular( () => {
      // the app scrolls on <body>, so listen in the capture phase to hear any scroller
      document.addEventListener( 'scroll', this.check, { capture: true, passive: true } );
      window.addEventListener( 'resize', this.check, { passive: true } );
      requestAnimationFrame( this.check );
    } );
  }

  ngOnDestroy(): void {
    if ( typeof document === 'undefined' ) { return; }
    document.removeEventListener( 'scroll', this.check, { capture: true } );
    window.removeEventListener( 'resize', this.check );
  }
}
